module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup",
    staticStyle: {
      "display": "block"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "left",
      "append-to-body": _vm.canJump,
      "content": '点击可跳转',
      "open-delay": 100
    }
  }, [(_vm.canJump && _vm.disabled) ? _c('div', {
    staticClass: "el-input is-disabled el-input__inner disabled_input",
    on: {
      "click": _vm.goEntityDetail
    }
  }, [_vm._v(_vm._s(_vm.lookupValue.name))]) : _c('el-input', {
    ref: "input",
    attrs: {
      "readonly": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.lookupValue.name),
      callback: function($$v) {
        _vm.$set(_vm.lookupValue, "name", $$v)
      },
      expression: "lookupValue.name"
    }
  }, [(!_vm.disabled) ? _c('i', {
    staticClass: "el-input__icon el-icon-search",
    staticStyle: {
      "z-index": "999"
    },
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showLookupDialog.apply(null, arguments)
      }
    },
    slot: "suffix"
  }) : _vm._e()])], 1), _vm._v(" "), _c('rt-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "entity": _vm.entity,
      "request-url": _vm.dialogRequestUrl,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "custom-conditions": _vm.dialogCustomConditions,
      "filter-fields": _vm.dialogFilterFields,
      "return-fields": _vm.dialogReturnFields,
      "dialog-extra-fields": _vm.dialogExtraFields
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3feacf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/lookup/src/lookup.vue
// module id = 2166
// module chunks = 228